import React from 'react';
import './SupplyRiskTab.styles.scss';

const SupplyRiskTab: React.FC = () => {
  return (
    <section className="content-section">
      <div className="section-header">
        <h3 className="section-title">Supply Chain & Operational Risk Analysis</h3>
        <small>Data compilation in progress | Coming soon</small>
      </div>
      <div className="section-content">
        <div className="supply-risk-placeholder">
          <i
            className="fas fa-database"
            style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.3 }}
          ></i>
          <h4>Supply Risk Analysis Coming Soon</h4>
          <p>
            We're currently compiling comprehensive supply chain data including FDA shortage
            histories, manufacturing capacity analysis, and operational risk assessments. This
            section will be available in the next platform update.
          </p>
          <div className="expected-features">
            <p>
              <strong>Expected Features:</strong>
            </p>
            <ul>
              <li>API supplier concentration analysis</li>
              <li>Manufacturing footprint mapping</li>
              <li>Historical shortage event tracking</li>
              <li>Capacity utilization metrics</li>
              <li>LOE timeline simulation</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupplyRiskTab;
